import React from "react";
import Slider from "react-slick";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function AppScreenshots() {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );
  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section
      id="screenshot"
      className={
        "section bg-light " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Conheça o Pelada+ por dentro</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Veja como cada detalhe foi pensado para facilitar a vida de quem só quer jogar bola sem dor de cabeça.
        </p>
        <Slider {...settings}>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/01.png" />
          </div>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/02.png" />
          </div>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/03.png" />
          </div>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/04.png" />
          </div>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/05.png" />
          </div>
          <div className="item shadow-sm">
            <img className="img-fluid" alt="" src="images/app/06.png" />
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default AppScreenshots;
